// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jhtyzjtthkezfznrhwnj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpodHl6anR0aGtlemZ6bnJod25qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc0NDk1MjAsImV4cCI6MjA5MzAyNTUyMH0.IxyXk274UuWBkxa0VbTrRUZhThqnsIDb5ahrMiplGmc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});